import { makeChartComp } from '../../../util/makeChartComp';
var TinyRingChart = makeChartComp('TinyRing');
export default TinyRingChart;
